import SmartySDK from 'smartystreets-javascript-sdk';

export default class SmartyAutocomplete {
  constructor() {
    const SmartyCore = SmartySDK.core;
    const key = process.env.GATSBY_SMARTY_EMBEDDED_KEY;
    const credentials = new SmartyCore.SharedCredentials(key);
    this.client = new SmartyCore.ClientBuilder(credentials)
      .withLicenses(['us-autocomplete-pro-cloud'])
      .buildUsAutocompleteProClient();
  }

  getSuggestions = async (searchString) => {
    const lookup = new SmartySDK.usAutocompletePro.Lookup(searchString);
    lookup.maxResults = 10;
    lookup.country = 'US';
    // Tells Smarty to use the sender's IP address to determine location,
    // then automatically add the city and state to the prefer_cities value.
    lookup.preferGeolocation = 'city';
    // "all" includes non-USPS addresses, which we want because it covers
    // physical registration addresses that can't receive mail.
    lookup.source = 'all';

    return this.client.send(lookup);
  };

  filterSuggestions = (suggestions) => {
    const seen = new Set();
    return suggestions.filter((item) => {
      const formatted = this.formatSuggestion(item);
      const duplicate = seen.has(formatted);
      seen.add(formatted);
      return !duplicate;
    });
  };

  formatSuggestion = (suggestion) => {
    return `${suggestion.streetLine}, ${suggestion.city}, ${suggestion.state} ${suggestion.zipcode}, United States`;
  };
}
